import React from 'react'
import AddRule from './AddRule'
import EditRule from './EditRule'
import Rules from './RuleListPage'

const ruleRoutes = [
  {
    breadcrumb: 'Rules',
    path: '',
    element: <Rules />,
    children: [],
  },
  {
    breadcrumb: 'Create',
    path: 'create',
    element: <AddRule />,
  },
  {
    breadcrumb: 'Detail',
    path: ':id',
    element: <EditRule />,
  },
]

export default ruleRoutes
